import React from "react";

interface MobileAuthPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const MobileAuthPopup: React.FC<MobileAuthPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-sm p-6 mx-4 max-w-sm w-full">
        <div className="text-center mb-8">
          <p className="text-gray-800 text-lg font-medium">
            MYKEEPiN을 실행하시겠습니까?
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 px-4 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors"
          >
            열기
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileAuthPopup;
